module.exports = __webpack_public_path__ + "img/graph-text_3.05eef7a0.svg";